import "./logo.scss";
import * as React from "react";
import { Link } from "react-router-dom";
import CDN from "../../../Utilities/Platform/CDN";

type Props = {
    onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

export default class Logo extends React.Component<Props> {
    public url = "/imgs/cloud.png?cache=true";

    public render(): React.ReactNode {
        return (
            <Link to="/" onClick={this.props.onClick} id="logo">
                <img
                    src={CDN(this.url)}
                    alt="Shopfront"
                    height="25"
                />
            </Link>
        );
    }
}
